import { axiosApiClient } from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/support";

class SupportService {
  // Get admin chat sessions
  getAdminSessions = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/admin/sessions`);
      
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching chat sessions.");
    }
  };

  // Get chat history for specific session
  getChatHistory = async (chatId) => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/sessions/${chatId}/messages`);
      
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching chat history.");
    }
  };

  // Create new chat session
  createChatSession = async (sessionData) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/sessions`, sessionData);
      
      if (response.status !== 200 && response.status !== 201) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while creating chat session.");
    }
  };

  // Send message in chat
  sendMessage = async (messageData) => {
    try {
      const { chatId, ...messagePayload } = messageData;
      const response = await axiosApiClient.post(`${BASE_URL}/sessions/${chatId}/messages`, messagePayload);
      
      if (response.status !== 200 && response.status !== 201) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while sending message.");
    }
  };

  // Close chat session
  closeChatSession = async (chatId) => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}/sessions/${chatId}/close`);
      
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while closing chat session.");
    }
  };

  // Assign agent to chat
  assignAgent = async (chatId, agentId) => {
    try {
      const response = await axiosApiClient.patch(`${BASE_URL}/chat/${chatId}/assign`, {
        agentId
      });
      
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while assigning agent.");
    }
  };

  // Get support agents
  getSupportAgents = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/agents`);
      
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching support agents.");
    }
  };

  // Email fallback
  sendEmailFallback = async (messageData) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/email-fallback`, messageData);
      
      if (response.status !== 200 && response.status !== 201) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while sending email fallback.");
    }
  };

  // Update agent status
  updateAgentStatus = async (status) => {
    try {
      const response = await axiosApiClient.patch(`${BASE_URL}/agent/status`, {
        status
      });
      
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while updating agent status.");
    }
  };

  // Get support statistics
  getSupportStats = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/stats`);
      
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching support statistics.");
    }
  };

}

const supportService = new SupportService();

export default supportService;